import React, { Fragment, useState, useEffect } from "react";
import { Col, Row } from "reactstrap";
import FutureIncomeComponent from "../components/Layout/FutureIncomeComponent/FutureIncomeComponent";
import { PageWrapper } from "../components/PageWrapper/PageWrapper";
import { Header } from "../components/Layout/Header/Header";
import { Safearea } from "../components/UI/Safearea/Safearea";

export const FutureIncome = () => {
  return (
  <React.Fragment>
    <Header title="Ingresos futuros" />
    <Safearea>
      <FutureIncomeComponent title={"Ingresos futuros"}/>
    </Safearea>
  </React.Fragment>
  );
};